import { render, staticRenderFns } from "./AutoCompleteTextInput.vue?vue&type=template&id=b5762b3e"
import script from "./AutoCompleteTextInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoCompleteTextInput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSurveyQuestion: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/Question.vue').default,IxFormInputCombobox: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/form-input/Combobox.vue').default})
